import { render, staticRenderFns } from "./SuperSearchResultsViewer.vue?vue&type=template&id=ba627e3a&scoped=true&"
import script from "./SuperSearchResultsViewer.vue?vue&type=script&lang=js&"
export * from "./SuperSearchResultsViewer.vue?vue&type=script&lang=js&"
import style0 from "./SuperSearchResultsViewer.vue?vue&type=style&index=0&id=ba627e3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba627e3a",
  null
  
)

export default component.exports